import { Universe } from '@smart-tv/typings/content';

import { kmmRequest } from './kmm';

interface RawUniverse {
  universeId: string | number;
  universeTitle: string;
}

const responseMapper = (universes: RawUniverse[]): Universe[] =>
  universes.map((universe) => ({
    id: Number(universe.universeId),
    title: universe.universeTitle
  }));

export async function getContentUniverses(): Promise<Universe[]> {
  const jsonResponse = await kmmRequest('getContentUniverses', {});
  const universes = JSON.parse(jsonResponse) as RawUniverse[];
  return responseMapper(universes);
}

export default getContentUniverses;
